import { formatMoney } from '@shopify/theme-currency';
const { Fancybox } = await import('@fancyapps/ui');

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;
    this.body = document.querySelector('body');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.applyDiscounts();
  }

  open() {
    this.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      if (section?.selector) {
        const selector = document.querySelector(section.selector);
        if (selector) {
          selector.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      }
    });

    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this))
    );

    this.applyDiscounts();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '[data-cart-drawer]',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }

  applyDiscounts() {
    let discountTitles = '';
    fetch(`${routes.cart_url}` + '.js')
      .then((response) => response.text())
      .then((text) => {
        let cartDrawerItems = JSON.parse(text).items;
        if (cartDrawerItems) {
          cartDrawerItems.forEach((item, index) => {
            discountTitles = '';
            if (item.discounts) {
              // collect discount titles
              item.discounts.forEach((discount) => {
                if (discount.title) {
                  discountTitles = discountTitles + '<span>' + discount.title + '</span>';
                  if (document.querySelector('[data-class-id="' + index + '"]')) {
                    // adjust quantity class
                    document
                      .querySelector('[data-class-id="' + index + '"]')
                      .classList.remove('mt-4', 'lg:mt-4');
                  }
                }
              });
              // add discount titles
              if (discountTitles) {
                if (document.querySelector('[data-discount-id="' + index + '"]')) {
                  document.querySelector('[data-discount-id="' + index + '"]').innerHTML =
                    discountTitles;
                }
              }
            }
            if (item.discounted_price < item.final_price) {
              if (document.querySelector('[data-price-id="' + index + '"]')) {
                // adjust sale price
                let itemQuantity = parseInt(
                  document.querySelector('[data-class-id="' + index + '"] input').value
                );
                document
                  .querySelector('[data-price-id="' + index + '"]')
                  .classList.add('has-discount');
                document.querySelector(
                  '[data-sale-price-id="' + index + '"]'
                ).innerHTML = `${formatMoney(
                  item.final_price * itemQuantity,
                  window.Shopify.currency.active
                )}`;
                document.querySelector('[data-regular-price-id="' + index + '"]').innerHTML = `${
                  (formatMoney(item.discounted_price * itemQuantity),
                  window.Shopify.currency.active)
                }`;
              }
            }
          });

          // rebind quantity change input
          this.cartItems = document.querySelector('cart-items');
          document.querySelectorAll('[data-quantity]').forEach((quantityInput) => {
            if (typeof quantityInput !== 'undefined' && quantityInput != null) {
              quantityInput.addEventListener('change', this.cartItems.debouncedOnChange.bind(this));
            }
          });
        }
        // bind cart upsells
        this.cartUpsells();
        this.cartItems.disableLoading();
      })
      .catch((e) => {
        console.error(e);
      });

    this.discountCode = document.querySelector('[data-discount-code]');
    this.discountSubmit = document.querySelector('[data-discount-submit]');
    if (this.discountSubmit) {
      this.discountSubmit.addEventListener('click', this.handleDiscountCode.bind(this));
    }

    // complete the look
    let completeLookTriggers = document.querySelectorAll('[data-quickshop]');
    completeLookTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        let productHandle = trigger.dataset.quickshop;
        if (productHandle) {
          fetch(location.origin + '/products/' + productHandle + '?view=quickshop')
            .then((response) => response.text())
            .then((text) => {
              new Fancybox(
                [
                  {
                    src: text,
                    type: 'html',
                  },
                ],
                {
                  mainClass: 'noheight',
                }
              );
              document.querySelector('cart-drawer').cartUpsells();
            });
        }
      });
    });

    // size guide
    let sizeGuides = document.querySelectorAll('[data-size-guide]');

    sizeGuides.forEach((sizeGuide) => {
      sizeGuide.addEventListener('click', (event) => {
        let pdfHandle = event.target.dataset.url;
        let type = 'pdf';
        if (pdfHandle.indexOf('.pdf') > -1) {
          type = 'image';
        }

        if (pdfHandle) {
          new Fancybox([
            {
              src: pdfHandle,
              type: 'image',
            },
          ]);
        }
      });
    });
  }

  cartUpsells() {
    let closeButtons = document.querySelectorAll('[data-cart-upsell-close]');
    let openButtons = document.querySelectorAll('[data-cart-upsell-open]');
    let variants = document.querySelectorAll('[data-cart-upsell-variant]');
    let atc = document.querySelectorAll('[data-cart-upsell-atc]');
    closeButtons.forEach((btn) => btn.addEventListener('click', this.closeUpsell.bind(this)));
    openButtons.forEach((btn) => btn.addEventListener('click', this.openUpsell.bind(this)));
    variants.forEach((btn) => btn.addEventListener('click', this.selectVariant.bind(this)));
    atc.forEach((btn) => btn.addEventListener('click', this.selectUpsell.bind(this)));
  }

  closeUpsell(event) {
    event.target.closest('[data-cart-upsell]').classList.remove('open');
  }

  openUpsell(event) {
    event.target.closest('[data-cart-upsell]').classList.add('open');
  }

  selectVariant(event) {
    if (event.target.closest('[data-cart-upsell]').querySelector('.variant-active')) {
      event.target
        .closest('[data-cart-upsell]')
        .querySelector('.variant-active')
        .classList.remove('variant-active');
    }
    event.target.parentNode.classList.add('variant-active');
  }

  selectUpsell(event) {
    event.target.classList.add('is-loading');
    event.target.parentNode.classList.add('is-loading');
    if (event.target.closest('[data-cart-upsell]').querySelector('.variant-active')) {
      let variantId = event.target
        .closest('[data-cart-upsell]')
        .querySelector('.variant-active span').dataset.cartUpsellVariantId;

      this.addUpsell(variantId);
    }
  }

  addUpsell(variantId) {
    let cart_url = `${routes.cart_add_url}`;
    let body = JSON.stringify({
      items: [
        {
          quantity: 1,
          id: parseFloat(variantId),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        },
      ],
    });

    fetch(cart_url, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        fetch(location.origin + '/?sections=cart-drawer,cart-icon-bubble')
          .then((response) => response.json())
          .then((data) => {
            let jsonData = data;
            jsonData.sections = data;
            Fancybox.close(true);
            this.drawer.renderContents(jsonData);
            this.drawer.open();
          });
      })
      .catch((error) => {
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
      });
  }

  handleDiscountCode(event) {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('[data-discount-submit]').classList.add('is-loading');
    if (this.discountCode.value) {
      event.target.closest('[data-collapsible-group]').classList.remove('error');

      // Setup the Apply Discount Code URL
      let discountCode = this.discountCode.value;
      let discountApplyUrl = location.origin + '/discount/' + discountCode;

      fetch(discountApplyUrl)
        .then((response) => response.text())
        .then((text) => {
          fetch(location.origin + '/?sections=cart-drawer,cart-icon-bubble')
            .then((response) => response.json())
            .then((data) => {
              let jsonData = {};
              jsonData.sections = data;
              this.drawer.renderContents(jsonData);
            });
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      event.target.closest('[data-collapsible-group]').classList.add('error');
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
